import toFixedValue from 'app/common/lib/toFixedValue'

import { extractDateAndNameFromColumnKey } from './create-column-keys'
import { headerCells } from './headers'
import { CommonRow } from './data'
import { ByPaymentMethodTotals, Entity } from './types'

export const createDataTotal = ({
  totals,
  columnKeysMain,
}: {
  totals: ByPaymentMethodTotals
  columnKeysMain: Array<string>
}) => {
  const totalsArrange = [
    { ...totals.internal, id: Entity.RowInternal },
    { ...totals.sbp, id: Entity.RowSbp },
    { ...totals.bank_card, id: Entity.RowBankCard },
    { ...totals.cash, id: Entity.RowCash },
    { ...totals.grand_total, id: Entity.RowGrandTotal },
  ]

  return totalsArrange.map(({ id, total: { count, sum }, data_by_date: dataByDate }) => ({
    rowKey: id,
    rowData: columnKeysMain.reduce(
      (acc, key) => {
        const [name, date] = extractDateAndNameFromColumnKey(key)
        const itemData = dataByDate[date]
        if (!itemData) {
          console.warn(`Не найдено поле ${date} в 'data_by_date' в данных отчета`)
          return acc
        }
        acc[key] = {
          columnKey: key,
          value: name === Entity.DateCount ? String(itemData.count) : toFixedValue(itemData.sum),
          type: 'isTotal',
        }
        return acc
      },
      {
        [Entity.Title]: {
          columnKey: Entity.Title as const,
          value: headerCells[id],
          type: 'isTotal',
        },
        [Entity.TotalCount]: {
          columnKey: Entity.TotalCount as const,
          value: count || count === 0 ? String(count) : '',
          type: 'isTotal',
        },
        [Entity.TotalSum]: {
          columnKey: Entity.TotalSum as const,
          value: toFixedValue(sum),
          type: 'isTotal',
        },
      } as CommonRow['rowData'],
    ),
  }))
}
